import React from "react";
import "./styles/Backdrop.scss";
const Backdrop = (props) => {
  function hideBackdrop() {
    var x = document.getElementsByClassName("backdrop");
    var displaySetting = x[0].style.display;

    if (displaySetting === "block") {
      x[0].style.display = "none";
    }
  }
  let formClasses = "backdrop";
  if (props.show) {
    formClasses = "backdrop open";
  }
  return props.trigger ? (
    <div
      className="backdrop"
      onClick={() => {
        props.setTrigger(false);
        hideBackdrop();
      }}
    ></div>
  ) : (
    ""
  );
};

export default Backdrop;
